import { object, mixed, boolean } from "yup";
import {
    cyrillicCityRequired,
    cyrillicNameRequired,
    emailRequired,
    phoneFormattedRequired,
} from "../../../shared/constants/yup";

export const VacancyShareSchema = object().shape({
    email: emailRequired,
});

export const VacancyOfferFormSchema = VacancyShareSchema.shape({
    name: cyrillicNameRequired,
    phone: phoneFormattedRequired,
    personalData: boolean().required(),
    resume: mixed<File>().default(null).required(),
});

export const VacancyApplyFormSchema = VacancyOfferFormSchema.shape({
    city: cyrillicCityRequired,
});
